import {field} from "../../stem-core/state/StoreField";
import {EditableObjectStatus, VisibilityStatus} from "./misc/GenericEnums";
import {MoneyObject} from "../../stem-core/localization/Money";
import {apiClient, type MerchantScopedRequest} from "../connection/BlinkApiClient";
import type {StoreId} from "../../stem-core/state/State";
import {ShippingPriceEntry, type RawShippingPriceEntry} from "./misc/ShippingPrice";
import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {Merchant} from "./MerchantStore";


@globalStore
export class Product extends BaseStore("Product", {}, MoneyObject) {
    declare alias: string;
    @field("Merchant") merchant: Merchant;
    @field(EditableObjectStatus) status: EditableObjectStatus;
    @field(VisibilityStatus) visibility: VisibilityStatus;
    @field(String) name: string;
    @field(String) description: string;
    @field(String) image: string; // Optional, the URL of the image
    @field(Number) inventorySize: number;
    @field(Boolean) allowMultiplePurchasesPerUser: boolean;
    @field(Boolean) allowArbitrarySubproducts: boolean;
    @field(Boolean) requiresAddress: boolean;

    @field(Object) shippingPrices: RawShippingPriceEntry[]; // The first matching entry is the one used

    // Return an array of ShippingPrice objects. Will modify the objects inline.
    getShippingPrices(): ShippingPriceEntry[] {
        return ShippingPriceEntry.loadArray(this.shippingPrices, this.currencyId);
    }
}

// CreateProductRequest (api/merchants/views.py)
export interface CreateProductRequest extends MerchantScopedRequest {
    name: string;
}

export async function apiMerchantCreateProduct(request: CreateProductRequest): Promise<Product> {
    const response = await apiClient.post("/merchant/create_product", request);
    // TODO @Mihai loadObject without index should probably at least log a warning
    //  if there are multiple objects (or None)
    return Product.loadObject(response);
}

// EditProductRequest. Everything but the id is optional: the endpoint is called with allowNulls, so a
// field present and null clears it, while one left out is untouched
export interface EditProductRequest extends MerchantScopedRequest {
    productId: StoreId;
    name?: string | null;
    alias?: string | null;
    description?: string | null;
    status?: EditableObjectStatus | null;
    visibility?: VisibilityStatus | null;
    amount?: number | null;
    requiresAddress?: boolean | null;
    image?: string | null;
    shippingPrices?: ShippingPriceEntry[] | null;
}

export async function apiMerchantEditProduct(request: EditProductRequest): Promise<any> {
    return apiClient.post("/merchant/edit_product", request, {allowNulls: true});
}
